



















































































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */
import CardCanvas from '@/layouts/card-canvas.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'
import ColorAssistant from '@/helpers/color-assistant'
import LocalStore from '@/helpers/localstore'

/* Data types */
import {
  IPersonBase,
  IStatusForSelection,
  IWorkflowForSelection,
} from '@/api/types/response.types'
import { IMailboxesInputCreate } from '@/api/types/request.types'
import { EEntities } from '@/types'

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'
import Avatar from '@/components/global/avatar.vue'

export default Vue.extend({
  metaInfo: {
    title: 'New Mailbox',
  },

  components: {
    CardCanvas,
    Avatar,
  },

  data() {
    return {
      EEntities,
      ColorAssistant,
      RouteAssistant,
      focusName: true,
      isLoading: true,
      isSubmitting: false,
      workflows: [] as IWorkflowForSelection[],
      showCreateWorkflowDrawer: false,
      newMailboxID: 0,
      assignedPeople: [] as IPersonBase[],
      allowInactiveUpdateStatusChange: true,

      // Input values
      name: '',
      selectedWorkflowID: null,
      inactiveUpdateStatusID: 0,
      enableJobs: this.$permissions.jobsFeatureEnabled,
    }
  },

  computed: {
    mailboxCreated(): boolean {
      return this.newMailboxID !== 0
    },
    selectedWorkflow(): IWorkflowForSelection {
      return this.workflows.find(w => w.id === this.selectedWorkflowID)
    },
    selectedWorkflowHasJobs(): boolean {
      if (!this.selectedWorkflow) {
        return false
      }
      return this.selectedWorkflow.listJobs.length > 0
    },
    statusesForSelection(): IStatusForSelection[] {
      return this.selectedWorkflow.listStatuses
    },
  },

  watch: {
    selectedWorkflowID: {
      handler(val) {
        // Default inactive update status id to the first...
        this.inactiveUpdateStatusID = this.selectedWorkflow.listStatuses[0].id
      },
    },
  },

  async created() {
    this.isLoading = true
    await this.getWorkflows()
    this.isLoading = false
    await this.$nextTick()
    this.selectedWorkflowID = this.workflows[0].id

    if (
      this.$route.query.workflow_id &&
      this.workflows.some(
        w => w.id.toString() === this.$route.query.workflow_id.toString(),
      )
    ) {
      this.selectedWorkflowID = this.$route.query.workflow_id
    }

    this.$nextTick(() => {
      // @ts-ignore
      this.$refs.nameRef.focus()
    })
  },

  methods: {
    goToMailboxVerificationIntro() {
      LocalStore.setShowInfoOnEntityLanding(this.newMailboxID)
      RouteAssistant.goToMailboxVerificationIntroRoute(
        this.$router,
        this.$route.params.accountId,
        this.newMailboxID,
      )
    },
    async handleWorkflowCreation(id: number) {
      await this.getWorkflows()

      const selectedWorkflow = this.workflows.find(w => w.id === id)
      const selectedIndex = this.workflows.findIndex(w => w.id === id)

      this.workflows.splice(selectedIndex, 1)
      this.workflows.unshift(selectedWorkflow)

      this.selectedWorkflowID = id
    },
    async getWorkflows() {
      this.workflows = await MailboxesAPI.get_Workflows()
    },
    async create() {
      if (this.name.trim().length === 0) {
        this.focusName = false
        await this.$nextTick()
        this.focusName = true
        this.$messaging.showError('Please enter a name.')
        return
      }
      this.isSubmitting = true
      try {
        const data = {
          name: this.name,
          workflowID: this.selectedWorkflowID,
          enableJobs: this.enableJobs,
          inactiveUpdateStatusID: this.allowInactiveUpdateStatusChange
            ? this.inactiveUpdateStatusID
            : null,
        } as IMailboxesInputCreate
        const response = await MailboxesAPI.post_Create(data)
        this.newMailboxID = response.id
      } catch (err) {
        this.$error.emit(err, true)
      } finally {
        this.isSubmitting = false
      }
    },
  },
})
